
      const device = {
  "deviceModel": "Модель",
  "deviceIMEI": "IMEI",
  "deviceExtra": "Экстра",
  "devicePhoneNo": "Номер телефона",
  "releaseDate": "Дата выпуска",
  "renewalDate": "Дата обновления",
  "finallyOnline": "В режиме online",
  "devicePower": "Мощность",
  "onlineStatu": "Статус online",
  "bandStatu": "Состояние ремешка",
  "deviceImage": "Изображение",
  "bandDestroy": "Разрушен",
  "bandOK": "OK",
  "bandUp": "Повреждена верхняя часть ремешка",
  "bandDown": "Повреждена нижняя часть ремешка",
  "total": "Всего",
  "vacancy": "Свободно",
  "other": "Другое",
  "overView": "Обзор",
  "deviceNumber": "Значение",
  "deviceStatusNormal": "Нормально",
  "deviceStatusUnbound": "Расстегнут",
  "incoming": "Входящий",
  "modifyOrg": "Модифицировать организацию",
  "packUp": "Закрыть",
  "expand": "Расширить",
  "IMEISearchPlaceholder": "Введите номер IMEI",
  "manuallyChoose": "Выбрать вручную",
  "deviceExportSuccess": "Файл был успешно загружен. {total} было импортировано устройство и {repeatNum} были импортированы дубликаты устройств",
  "deviceExportFailed": "Сбой загрузки",
  "noModifiedDevices": "Нет модифицированных устройств",
  "modifiedSuccess": "Успешно",
  "deviceModifyTemplate": "Модификация шаблона",
  "remark": "Ремарка",
  "newRemark": "Новая ремарка",
  "securitySeal": "Пломба",
  "newSecuritySeal": "Новая пломба",
  "changeRemark": "Изменить ремарку"
}
      export default device
    